import { useState } from 'react';

import { useResizeObserver } from './useResizeObserver';

export const useMeasureHeight = <T extends HTMLElement = HTMLElement>() => {
  const [height, setHeight] = useState<number>(0);

  const [ref] = useResizeObserver<T>({
    onResize: (rect) => {
      if (rect.height !== height) {
        setHeight(rect.height);
      }
    },
  });

  return [ref, { height }] as const;
};
